var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import Section from "../../entities/Section";
import { getDictFirstVal } from '../common';
import { getElementsByQuerySelectorAll } from '../../../pxc_editor_web/src/helpers';
export var parseId = function (id) {
    var pageId = id.split('L')[0];
    var layoutId = id.split('L')[1] ? id.split('G')[0] : null;
    var groupId = id.split('G')[1] ? id.split('S')[0] : null;
    var shieldId = id.split('S')[1] ? id.split('---')[0] : null;
    var sectionId = id.split('---')[1] ? id : null;
    return {
        pageId: pageId,
        layoutId: layoutId,
        groupId: groupId,
        shieldId: shieldId,
        sectionId: sectionId,
    };
};
export var getAllLayers = function (id, pages) {
    var _a = parseId(id), pageId = _a.pageId, layoutId = _a.layoutId, groupId = _a.groupId, shieldId = _a.shieldId, sectionId = _a.sectionId;
    var page = pages[pageId];
    var layout = null, group = null, shield = null, section = null;
    if (page) {
        layout = layoutId ? page.layouts[layoutId] : null;
        if (sectionId) {
            section = page.sections[sectionId];
        }
        if (layout) {
            group = groupId ? layout.groups[groupId] : null;
            if (group) {
                shield = shieldId ? group.shields[shieldId] : null;
            }
        }
    }
    return { page: page, layout: layout, group: group, shield: shield, section: section };
};
export var getFirstLayers = function (pages) {
    var page = getDictFirstVal(pages);
    var layout = getDictFirstVal(page.layouts);
    var group = getDictFirstVal(layout.groups);
    var shield = getDictFirstVal(group.shields);
    var section = null;
    for (var secId in page.sections) {
        if (page.sections[secId].shieldId === shield.id) {
            section = page.sections[secId];
            break;
        }
    }
    return { page: page, layout: layout, group: group, shield: shield, section: section };
};
export var hasShapeContent = function (shape, page) {
    var sections = page.sections;
    for (var secId in sections) {
        if (sections[secId].shieldId === shape.id) {
            if (sections[secId].glyph ||
                sections[secId].code ||
                sections[secId].image ||
                (sections[secId].text && sections[secId].text.length)) {
                return true;
            }
            else {
                return false;
            }
        }
    }
    return false;
};
export var getShieldSectionsArray = function (shield, sections) {
    var res = [];
    for (var secId in sections) {
        var sec = sections[secId];
        if (sec && sec.shieldId === shield.id) {
            res.push(sec);
        }
    }
    return res;
};
export var getGroupShieldsArray = function (group) {
    var shields = [];
    for (var shId in group.shields) {
        shields.push(group.shields[shId]);
    }
    return shields;
};
export var getPageObjects = function (page) {
    var layouts = {};
    var groups = {};
    var shields = {};
    for (var layoutId in page.layouts) {
        var layout = page.layouts[layoutId];
        layouts[layoutId] = layout;
        for (var groupId in layout.groups) {
            var group = layout.groups[groupId];
            groups[groupId] = group;
            for (var shieldId in group.shields) {
                shields[shieldId] = group.shields[shieldId];
            }
        }
    }
    return { layouts: layouts, groups: groups, shields: shields, sections: page.sections };
};
export var clearShield = function (page, shieldId) {
    var newSections = {};
    Object.values(page.sections).filter(function (s) { return s.shieldId !== shieldId; }).forEach(function (sec) {
        newSections[sec.id] = sec;
    });
    page.sections = newSections;
    return page.sections;
};
export var applyPageWidthToPage = function (length, page, selWizard) {
    var _a;
    var _b, _c, _d, _e;
    var layouts = page.layouts, sections = page.sections, solid = page.solid, uid = page.uid, _decorations = page.decorations;
    var decorations = Array.isArray(_decorations) ? _decorations : [];
    var newDecorations = __spreadArray([], __read(decorations), false);
    var flagMidLength = 0;
    var flagLength = 0;
    var newLength = length;
    var shieldPosY = 0;
    var shieldHeight = 0;
    if ((selWizard === null || selWizard === void 0 ? void 0 : selWizard.application_type) === 'CABLE_FLAG' && (uid === null || uid === void 0 ? void 0 : uid.length) && ((_b = selWizard === null || selWizard === void 0 ? void 0 : selWizard.data) === null || _b === void 0 ? void 0 : _b.pages) && ((_c = selWizard === null || selWizard === void 0 ? void 0 : selWizard.data) === null || _c === void 0 ? void 0 : _c.pages[uid])) {
        flagMidLength = Math.ceil(selWizard.data.flagMidLength);
        flagLength = Math.ceil(selWizard.data.pages[uid].flagLength * 10) / 10;
        newLength = flagLength;
    }
    var newLayouts = {};
    for (var layoutId in layouts) {
        var newGroups = {};
        var groups = layouts[layoutId].groups;
        for (var groupId in groups) {
            var newShields = {};
            var shields = groups[groupId].shields;
            for (var shId in shields) {
                var shield = shields[shId];
                shieldPosY = shield.primitiveProps.y;
                shieldHeight = shield.primitiveProps.h;
                newShields[shId] = __assign(__assign({}, shield), { primitiveProps: __assign(__assign({}, shield.primitiveProps), { w: newLength }) });
            }
            if ((selWizard === null || selWizard === void 0 ? void 0 : selWizard.application_type) === 'CABLE_FLAG' && (selWizard === null || selWizard === void 0 ? void 0 : selWizard.data)) {
                var _newShields = Object.values(newShields).sort(function (a, b) { return a.primitiveProps.x - b.primitiveProps.x; });
                newShields[_newShields[1].id].primitiveProps.x = flagLength + flagMidLength;
            }
            newGroups[groupId] = __assign(__assign({}, groups[groupId]), { shields: newShields });
        }
        newLayouts[layoutId] = __assign(__assign({}, layouts[layoutId]), { groups: newGroups });
    }
    var newSolids = solid.map(function (solid) {
        var primitiveType = solid.primitiveType, primitiveProps = solid.primitiveProps;
        if (primitiveType === 'rect') {
            if ((selWizard === null || selWizard === void 0 ? void 0 : selWizard.application_type) === 'CABLE_FLAG') {
                return __assign(__assign({}, solid), { primitiveProps: __assign(__assign({}, primitiveProps), { x: flagLength, w: flagMidLength }) });
            }
            else {
                return __assign(__assign({}, solid), { primitiveProps: __assign(__assign({}, primitiveProps), { w: length }) });
            }
        }
        return primitiveProps;
    });
    if ((_d = selWizard === null || selWizard === void 0 ? void 0 : selWizard.data) === null || _d === void 0 ? void 0 : _d.withMiddleLine) {
        var strokeWidth = selWizard.data.lineThickness;
        var shortDash = shieldHeight / 19;
        var longDash = shortDash * 3;
        var strokeDasharray = ((_e = selWizard === null || selWizard === void 0 ? void 0 : selWizard.data) === null || _e === void 0 ? void 0 : _e.lineType) === 'dashed' ? '' + longDash + ' ' + shortDash : '6 0';
        newDecorations.push({
            id: page.uid + "-solid-mid-line-" + Number(new Date()),
            primitiveType: "line",
            primitiveProps: {
                start_point: {
                    x: flagLength + flagMidLength / 2,
                    y: shieldPosY,
                },
                end_point: {
                    x: flagLength + flagMidLength / 2,
                    y: shieldPosY + shieldHeight,
                },
                style: {
                    strokeWidth: strokeWidth,
                    stroke: '#000000',
                    strokeDasharray: strokeDasharray
                }
            },
            logicalType: "solid",
            fillColor: "#ffffff",
            strokeColor: "#000000",
            shield_definition_id: null,
            shield_id: null,
            printable: true
        });
    }
    var newSections = __assign({}, sections);
    for (var secId in sections) {
        var shield = getAllLayers(secId, (_a = {}, _a[page.uid] = page, _a)).shield;
        var section = sections[secId];
        if (shield && section && !(shield.isMatrix && shield.isMatrixFixedCellWidth)) {
            var _f = shield.primitiveProps, x = _f.x, y = _f.y, w = _f.w, h = _f.h;
            var width = section.width, height = section.height, secX = section.x, secY = section.y;
            if (Math.abs(x - secX) < 0.001 &&
                Math.abs(y - secY) < 0.001 &&
                Math.abs(w - width) < 0.001 &&
                Math.abs(h - height) < 0.001) {
                if ((selWizard === null || selWizard === void 0 ? void 0 : selWizard.application_type) === 'CABLE_FLAG' && (selWizard === null || selWizard === void 0 ? void 0 : selWizard.data)) {
                    newSections[secId] = Section.fromDict(section).clone().toDict();
                }
                else {
                    newSections[secId] = Section.fromDict(section).clone().setWidth(newLength).toDict();
                }
            }
        }
    }
    return __assign(__assign({}, page), { box: __assign(__assign({}, page.box), { r: length }), solid: newSolids, decorations: newDecorations, layouts: newLayouts, sections: newSections });
};
export var copySectionToShield = function (sourceSection, targetShield, pages, rotateTarget180) {
    var e_1, _a;
    var sourceShield = getAllLayers(sourceSection.id, pages).shield;
    var targetPage = getAllLayers(targetShield.id, pages).page;
    if (sourceShield && targetPage) {
        var _b = sourceShield.primitiveProps, sourceShieldX = _b.x, sourceShieldY = _b.y, sourceShieldW = _b.w, sourceShieldH = _b.h;
        var _c = targetShield.primitiveProps, targetShieldX = _c.x, targetShieldY = _c.y, targetShieldW = _c.w, targetShieldH = _c.h;
        var existSectionsArr = getShieldSectionsArray(targetShield, targetPage.sections);
        var lastSecIndex = -1;
        try {
            for (var existSectionsArr_1 = __values(existSectionsArr), existSectionsArr_1_1 = existSectionsArr_1.next(); !existSectionsArr_1_1.done; existSectionsArr_1_1 = existSectionsArr_1.next()) {
                var sec = existSectionsArr_1_1.value;
                var secIndex = parseInt(sec.id.split('---')[1]);
                if (secIndex > lastSecIndex) {
                    lastSecIndex = secIndex;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (existSectionsArr_1_1 && !existSectionsArr_1_1.done && (_a = existSectionsArr_1.return)) _a.call(existSectionsArr_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var secData = existSectionsArr.find(function (el) { return el.sourceSectionId === sourceSection.id; });
        var secCopy = void 0;
        if (secData) {
            secCopy = Section.fromDict(secData);
            secCopy.copySection(sourceSection);
        }
        else {
            secCopy = Section.fromDict(sourceSection).clone();
            secCopy.id = "".concat(targetShield.id, "---").concat(lastSecIndex + 1);
            secCopy.shieldId = targetShield.id;
            secCopy.sourceSectionId = sourceSection.id;
        }
        var isGridDisplayed = getElementsByQuerySelectorAll('select-area-dot').length > 0;
        var centerByTargetShield = true;
        if (isGridDisplayed
            || sourceSection.angle !== 0
            || sourceSection.width !== sourceShieldW
            || sourceSection.height !== sourceShieldH
            || sourceSection.x !== sourceShieldX
            || sourceSection.y !== sourceShieldY) {
            centerByTargetShield = false;
        }
        var _x = targetShieldX + (sourceSection.x - sourceShieldX);
        var _y = targetShieldY + (sourceSection.y - sourceShieldY);
        if (!!rotateTarget180) {
            var offset_x = _x - targetShieldX;
            var offset_y = _y - targetShieldY;
            _x = targetShieldX + targetShieldW - offset_x - secCopy.width;
            _y = targetShieldY + targetShieldH - offset_y - secCopy.height;
            var slaveAngle = secCopy.angle + 180;
            slaveAngle = slaveAngle >= 360 ? slaveAngle - 360 : slaveAngle;
            secCopy.setAngle(slaveAngle);
        }
        secCopy
            .setX(_x)
            .setY(_y);
        if (centerByTargetShield) {
            secCopy
                .setWidth(targetShieldW)
                .setHeight(targetShieldH);
        }
        return secCopy;
    }
    return null;
};
export var getSelectedSections = function (data) {
    var sectionsSelection = data.sectionsSelection, page = data.page;
    return Object.keys(sectionsSelection).reduce(function (acc, id) {
        var _a;
        if (page.sections[id]) {
            return __assign(__assign({}, acc), (_a = {}, _a[id] = page.sections[id], _a));
        }
        return acc;
    }, {});
};
export var getSortedSelectedSections = function (data) {
    var sectionsSelection = data.sectionsSelection, page = data.page;
    return Object.keys(sectionsSelection)
        .sort(function (a, b) {
        var _a, _b;
        var numA = parseInt(((_a = a.match(/G(\d+)S(\d+)/)) === null || _a === void 0 ? void 0 : _a[1]) || '0', 10);
        var numB = parseInt(((_b = b.match(/G(\d+)S(\d+)/)) === null || _b === void 0 ? void 0 : _b[1]) || '0', 10);
        return numA - numB;
    })
        .reduce(function (acc, id) {
        if (page.sections[id]) {
            return __spreadArray(__spreadArray([], __read(acc), false), [page.sections[id]], false);
        }
        return acc;
    }, []);
};
export var getSortedSectionsArray = function (sectionsObj) {
    return Object.values(sectionsObj).sort(function (a, b) {
        // Primary sort: top-to-bottom (y coordinate)
        if (a.y !== b.y) {
            return a.y - b.y;
        }
        // Secondary sort: left-to-right (x coordinate)
        return a.x - b.x;
    });
};
